import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/prepHeaders';
import { ApiType } from '../utils/typeTransformer';
import { GetDashboard as GetDashboardType } from '@/types/projectManagementDashboardType';

export type args = {
  getProjectManagementDashboard: ApiType<GetDashboardType>['args'];
};

export type responses = {
  getProjectManagementDashboard: ApiType<GetDashboardType>['response'];
};

export const projectManagementDashboardApi = createApi({
  reducerPath: 'projectManagementDashboardApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['ProjectManagementDashboard'],

  endpoints: (builder) => ({
    // ---------------------------------------------------------
    // GET /api/rfi/project-management/dashboard/?project=...
    // ---------------------------------------------------------
    getProjectManagementDashboard: builder.query<
      responses['getProjectManagementDashboard'],
      args['getProjectManagementDashboard']
    >({
      query: ({ query }) => ({
        url: `/rfi/project-management/dashboard/`,
        method: 'GET',
        params: query,
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      keepUnusedDataFor: 60, // dashboard can be fairly “live”
      providesTags: (_r, _e, arg) => [
        { type: 'ProjectManagementDashboard', id: `project-${arg.query.project}` },
      ],
    }),
  }),
});

export const { useGetProjectManagementDashboardQuery } = projectManagementDashboardApi;

export namespace ProjectManagementDashboardApi {
  export const Api = projectManagementDashboardApi;
  export type Args = args;
  export type Responses = responses;
}
